import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';

export const ToggleButton = styled(IconButton)(({ theme }) => ({
  position: 'fixed',
  right: 20,
  top: 20,
  zIndex: 1100,
  backgroundColor: 'white',
  boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
  '&:hover': {
    backgroundColor: '#f5f5f5',
  },
  transition: 'all 0.3s ease',
  width: 48,
  height: 48,
  [theme.breakpoints.down('sm')]: {
    right: 16,
    top: 16,
  },
}));

export const DrawerContainer = styled('div')<{ isOpen: boolean }>(({ theme, isOpen }) => ({
  position: 'fixed',
  top: 0,
  right: isOpen ? 0 : -400,
  width: 400,
  height: '100vh',
  backgroundColor: 'white',
  boxShadow: '-2px 0 8px rgba(0,0,0,0.1)',
  zIndex: 1001,
  transition: 'right 0.3s ease',
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    right: isOpen ? 0 : '-100%',
  },
}));

export const DrawerBackdrop = styled('div')<{ isOpen: boolean }>(({ theme, isOpen }) => ({
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0,0,0,0.3)',
  zIndex: 1000,
  opacity: isOpen ? 1 : 0,
  visibility: isOpen ? 'visible' : 'hidden',
  transition: 'opacity 0.3s ease',
})); 